<div class="dashboard-card card">
  <div class="card-body dashboard-card-content">
    <div class="card-title">
      <span class="title" translate>SUMMARY</span>
    </div>
    <lib-invoice-statistics-chart [preConditions]="preConditions"></lib-invoice-statistics-chart>
  </div>
</div>
